<script setup lang="ts">
interface Props {
  nodeClass?: string
  branchClass?: string
  contentClass?: string
}
defineProps<Props>()
</script>

<template>
  <div :class="['relative flex items-start', nodeClass]">
    <div :class="['tree-branch-container', '-mt-3', branchClass]">
      <svg
        width="24"
        height="32"
        stroke-width="1.5"
        viewBox="0 -8 24 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        class="h-10 w-8 text-foreground-disabled"
      >
        <path
          d="M13.25 19.25L16.75 15.75L13.25 12.25"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.75 15.75H10.75C8.54086 15.75 6.75 13.9591 6.75 11.75V-20"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div :class="['tree-content', contentClass]">
      <slot name="content" />
    </div>
  </div>
</template>

<style scoped>
.tree-branch-container {
  flex-shrink: 0;
}
</style>
